import { z } from "zod";

const isProduction = import.meta.env.PROD;

const envSchema = z.object({
	VITE_APP_NAME: z.string().default("UpSquad"),
	VITE_SERVER_URL: z.url().default(isProduction ? "https://api.upsquad.us" : "http://localhost:8888"),
	VITE_APP_URL: z.url().default(isProduction ? "https://app.upsquad.us" : "http://localhost:3000"),
	VITE_CALENDLY_URL: z.url().default("https://calendly.com/upsquad"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
	throw new Error(`Invalid landing env: ${parsed.error.issues.map((i) => `${i.path.join(".")}: ${i.message}`).join(", ")}`);
}

export const env = {
	APP_NAME: parsed.data.VITE_APP_NAME,
	SERVER_URL: parsed.data.VITE_SERVER_URL,
	APP_URL: parsed.data.VITE_APP_URL,
	CALENDLY_URL: parsed.data.VITE_CALENDLY_URL,
};
